import React from "react";

// Assets
import IconPlayButton from "../../../Assets/SVGs/Icons/VideoPlayer/PlayButton";

interface FrontTrailerSectionProps {
    onOpenTrailer: () => void;
}

const FrontTrailerSection: React.FC<FrontTrailerSectionProps> = ({
    onOpenTrailer,
}) => (
    <section
        id="trailer"
        className="front-trailer"
        aria-labelledby="front-trailer-heading"
        tabIndex={-1}
    >
        <div className="front-trailer__background" aria-hidden="true" />
        <div className="front-trailer__overlay" aria-hidden="true" />

        <div className="front-trailer__inner">
            <div className="front-trailer__copy">
                <p className="front-trailer__kicker">
                    Meet Ickonic
                </p>
                <h2 id="front-trailer-heading">
                    A different point of view starts here.
                </h2>
                <p>
                    Discover original documentaries, fearless current affairs and
                    independent voices that challenge the stories you have been told.
                </p>
            </div>

            <button
                className="front-trailer__play"
                type="button"
                aria-label="Play the platform trailer"
                onClick={onOpenTrailer}
            >
                <span aria-hidden="true">
                    <IconPlayButton iconFill="currentColor" />
                </span>
            </button>

            <p className="front-trailer__caption">
                Play platform trailer <span>00:33</span>
            </p>
        </div>
    </section>
);

export default FrontTrailerSection;
